import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';

export class Menu extends Component {
    state = {
            show: false,
    }
    render() {
        return (
            <Router>
                <nav className="main-menu">         
                    <ul className="menu">
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/'} className="mega-menu-link">Home</a>
                            <ul className="mega-submenu">
                                <li><a href={process.env.PUBLIC_URL + '/'}>Home 01</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/home2'}>Home 02</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/home3'}>Home 03</a></li>
                            </ul>
                        </li>
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/about_us'} className="mega-menu-link">Pages</a>
                            <ul className="mega-submenu">
                                <li><a href={process.env.PUBLIC_URL + '/about_us'}>About Us</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/about_us_2'}>About us 2</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/contact_01'}>Contact us 01</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/contact_02'}>Contact us 02</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/services'}>Services 1</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/services_2'}>Services 2</a></li>                                
                                <li><a href={process.env.PUBLIC_URL + '/Our_team'}>Our Team</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Team_details'}>Team Details</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Pricing'}>Pricing</a></li>
                            </ul>
                        </li>
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/Alterations_repairs'} className="mega-menu-link">services</a>
                            <ul className="mega-submenu">
                                <li><a href={process.env.PUBLIC_URL + '/Alterations_repairs'}>Alterations & repairs</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Commercial_laundry'}>Commercial laundry</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/dry_cleaning'}>Dry cleaning</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Laundry_services'}>Laundry services</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Leather_cleaning'}>Leather cleaning</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Steam_iron'}>Steam iron</a></li>
                            </ul>
                        </li>
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/Our_case_study'} className="mega-menu-link">Case Study</a>
                            <ul className="mega-submenu">
                                <li><a href={process.env.PUBLIC_URL + '/Our_case_study'}>Our Case Study</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Case_study_details'}>Case Study Details</a></li>
                            </ul>
                        </li>
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/Blog'} className="mega-menu-link">Blog</a>
                            <ul className="mega-submenu">
                                <li><a href={process.env.PUBLIC_URL + '/Blog'}>Blog</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Blog_grid_view'}>Blog grid view</a></li>
                                <li><a href={process.env.PUBLIC_URL + '/Blog_details'}>Blog Details</a></li>
                            </ul>
                        </li>                    
                        <li className="mega-menu-item">
                            <a href={process.env.PUBLIC_URL + '/contact_01'} className="mega-menu-link">Contact Us</a>
                        </li>
                    </ul>
                </nav>
            </Router>
        )
        
    }
}

export default Menu;